export { STATE_NAME } from './constants';
export { default as reducer } from './reducer';
export { getFavoriteListings } from './actions';
export { getEntries, getListingsCount, isError } from './selectors';
import FavoriteListing from './containers/FavoriteListing';

export default FavoriteListing;
